export const PRIVACY_LAST_UPDATED = "April 19, 2026";
export const PRIVACY_EFFECTIVE_DATE = "April 19, 2026";
// Bump this whenever the Privacy Policy is materially updated.
// Used as the durable record of which version a user accepted in
// `public.terms_acceptances.privacy_version`.
export const PRIVACY_VERSION = "2026-04-19";

export interface PrivacySection {
  id: string;
  title: string;
}

export const PRIVACY_SECTIONS: PrivacySection[] = [
  { id: "intro", title: "1. Introduction" },
  { id: "scope", title: "2. Who This Policy Applies To" },
  { id: "data-we-collect", title: "3. Information We Collect" },
  { id: "how-we-use", title: "4. How We Use Your Information" },
  { id: "legal-bases", title: "5. Legal Bases (GDPR / UK GDPR)" },
  { id: "ai-and-content", title: "6. AI, Journal Content & Model Training" },
  { id: "sharing", title: "7. How We Share Information" },
  { id: "subprocessors", title: "8. Sub-Processors & Service Providers" },
  { id: "international", title: "9. International Data Transfers" },
  { id: "retention", title: "10. Data Retention" },
  { id: "security", title: "11. Security" },
  { id: "your-rights", title: "12. Your Rights & Choices" },
  { id: "ccpa", title: "13. California Privacy Rights (CCPA / CPRA)" },
  { id: "cookies", title: "14. Cookies & Similar Technologies" },
  { id: "children", title: "15. Children's Privacy" },
  { id: "do-not-track", title: "16. Do Not Track & Global Privacy Control" },
  { id: "third-party-links", title: "17. Third-Party Links" },
  { id: "breach", title: "18. Data Breach Notification" },
  { id: "changes", title: "19. Changes to This Policy" },
  { id: "contact", title: "20. Contact Us" },
];
